import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/data";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="lilac-blur" style={{ top: "-200px", right: "-200px", opacity: 0.5 }} />

      <div className="max-w-5xl mx-auto px-6 md:px-10 relative z-10 text-center">
        <div className="eyebrow mb-5">— Kind Words</div>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brown-dark leading-[1.05] tracking-tight">
          What our <em className="italic text-lilac-dark">regulars</em> are saying.
        </h2>

        <div
          key={i}
          data-testid="testimonial-card"
          className="mt-14 bg-cream-alt border border-[#E6DEC3] rounded-[2.5rem] p-10 md:p-16 relative reveal is-visible"
        >
          <Quote
            className="absolute top-8 left-8 text-lilac-dark/40"
            size={56}
            strokeWidth={1}
          />
          <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-[1.35] text-brown-dark max-w-3xl mx-auto relative">
            "{t.quote}"
          </p>
          <div className="mt-8">
            <div className="font-serif text-xl text-brown-dark">{t.name}</div>
            <div className="eyebrow mt-1">{t.breed}</div>
          </div>
        </div>

        <div className="mt-8 flex items-center justify-center gap-4">
          <button
            onClick={prev}
            data-testid="testimonial-prev-button"
            className="h-12 w-12 rounded-full border border-[#E6DEC3] bg-cream hover:bg-lilac-soft text-brown-dark flex items-center justify-center transition-colors"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, k) => (
              <button
                key={k}
                onClick={() => setI(k)}
                data-testid={`testimonial-dot-${k}`}
                aria-label={`Go to testimonial ${k + 1}`}
                className={`h-2 rounded-full transition-all duration-300 ${
                  k === i ? "w-8 bg-brown-dark" : "w-2 bg-brown-dark/25"
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            data-testid="testimonial-next-button"
            className="h-12 w-12 rounded-full border border-[#E6DEC3] bg-cream hover:bg-lilac-soft text-brown-dark flex items-center justify-center transition-colors"
            aria-label="Next testimonial"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
